const DESIGNER_PRO = 'builder';
const DESIGNER_BASIC = 'designer';

export { DESIGNER_PRO, DESIGNER_BASIC };
